import { render } from "./BookingConfirmPayment.vue?vue&type=template&id=a82ffcd6&scoped=true"
import script from "./BookingConfirmPayment.vue?vue&type=script&lang=js"
export * from "./BookingConfirmPayment.vue?vue&type=script&lang=js"

import "./BookingConfirmPayment.vue?vue&type=style&index=0&id=a82ffcd6&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.member/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a82ffcd6"]])

export default __exports__